import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { ConfigService } from "src/app/core/config.service";
import { GcpChartsData, GcpResourceDetails, GcpResources } from "./gcp-resources.model";
import {GcpResourceTypeEnum} from "src/app/shared/enum/gcp-resource-type.enum";

@Injectable({
    providedIn: 'root'
})
export class GcpResourcesService {

    constructor(private httpClient: HttpClient, private configService: ConfigService){

    }

    loadGcpResources(organizationId: string){
        return this.httpClient.get<GcpResources>(`${this.configService.config.apiUrl}/iac/resources/gcp?organization=${organizationId}`)
        .pipe(
            map((response=>{
                const data: any[] = []
                const gcpEnumKeys = Object.keys(GcpResourceTypeEnum);
                for(let type in response){
                    const resources = response[type as keyof GcpResources]
                    if(gcpEnumKeys.includes(type)){
                        data.push(...resources.checked.map((value) => {return {...value, type: type}}))
                        data.push(...resources.unchecked.map((value) => {return {...value, type: type}}))
                        data.push(...resources.ignored.map((value) => {return {...value, type: type}}))
                    }
                }
                return data
            }))
        )
    }

    loadGcpResourceDetails(tenant: string, resourceId: string){
        return this.httpClient.get<GcpResourceDetails>(`${this.configService.config.apiUrl}/iac/resources/gcp/details?organization=${tenant}&resource_id=${resourceId}`)
    }

    loadGcpMeasures(tenant: string, start_date: string, end_date: string, granularity: string){
        return this.httpClient.get<GcpChartsData>(`${this.configService.config.apiUrl}/iac/resources/gcp/measures?organization=${tenant}&start_date=${start_date}&end_date=${end_date}&granularity=${granularity}`)
    }
}
